import { handleHttpResponse } from "../../utils/http_response_utils";

export const getPlatformData = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-platform-names", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};
